import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "logout-page" }
const _hoisted_2 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis mb-2"
}
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "logout-card",
      elevation: "4",
      rounded: "xl"
    }, {
      default: _withCtx(() => [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "logout-head" }, [
          _createElementVNode("img", {
            src: "/email/lux-logo.png",
            alt: "Lux Modus",
            width: "210"
          })
        ], -1)),
        ($options.currentRouteName === 'Unauthorized')
          ? (_openBlock(), _createBlock(_component_v_card_text, {
              key: 0,
              class: "pa-8 text-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "warning",
                  size: "44"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-account-alert-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "text-h6 mt-2 mb-1" }, "User account is not authorized", -1)),
                ($options.supportEmail)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                      _cache[1] || (_cache[1] = _createTextVNode("Please contact ", -1)),
                      _createElementVNode("a", {
                        href: `mailto:${$options.supportEmail}`
                      }, _toDisplayString($options.supportEmail), 9, _hoisted_3)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_card_text, {
              key: 1,
              class: "pa-8 text-center"
            }, {
              default: _withCtx(() => [
                _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "text-h6 mb-1" }, "You have been signed out", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-body-2 text-medium-emphasis mb-6" }, "Taking you back to the sign-in page…", -1)),
                _createVNode(_component_v_progress_circular, {
                  class: "mb-6",
                  indeterminate: "",
                  color: "primary",
                  size: "44",
                  width: "4"
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  size: "large",
                  block: "",
                  to: { name: 'Login' }
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("Sign in now", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ]))
}